
export enum PartesSituacao {
  ATIVO = 'ATIVO',
  INATIVO = 'INATIVO',
  SUSPENSO = 'SUSPENSO',
  BAIXADO = 'BAIXADO'
}
